import React, { Component } from 'react'
import { connect } from 'react-redux'
import WebRTCStats from 'components/WebRTCStats'
import { getWebRtcStats } from 'actions/api/stats'



class WebRTCStatsContainer extends Component {
  render() {
    const {
      data,
      loading,
      statusCode,
      getWebRtcStats
    } = this.props

    return (
      <WebRTCStats
        statsData={data}
        loading={loading}
        statusCode={statusCode}
        getWebRtcStats={getWebRtcStats}
      />
    )
  }
}

function mapStateToProps (state) {
  return {
    data: state.webRtcStats.data,
    loading: state.webRtcStats.loading,
    statusCode: state.webRtcStats.statusCode
  }
}

function mapDispatchToProps (dispatch) {
  return {
    getWebRtcStats: (visitId, token, onFailure) => dispatch(getWebRtcStats(visitId, token, onFailure))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WebRTCStatsContainer)
